import { Avatar, Typography } from "@suraasa/placebo-ui"
import PageContainer from "components/PageContainer"
import CPATLogo from "features/Cpat/assets/cpat-mini-logo.png"
import { context } from "global/Context/context"
import { useContext } from "react"
import { buildUserName, formatDate } from "utils/helpers"

const GradientHeader = ({ dateCreated }: { dateCreated: string }) => {
  const { authInfo, profile } = useContext(context)

  if (!authInfo) return null

  const fullName = buildUserName(authInfo.user)

  return (
    <div
      className="-z-10 h-[30vh] w-full"
      style={{
        background:
          "linear-gradient(180deg, #D9E9FF 0%, #F4F6FA 62.02%, #F3F5F8 100%)",
      }}
    >
      {/* Grid pattern overlay */}
      <div
        className="absolute inset-0 h-[30vh]"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(255,255,255,0.5) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.5) 1px, transparent 1px)
          `,
          backgroundSize: "24px 24px",
        }}
      />
      <PageContainer className="relative z-10 h-full pb-10 pt-6">
        <div className="flex h-full flex-col justify-between gap-3">
          <div className="flex flex-row items-center gap-1">
            <img src={CPATLogo} alt="cpat logo" width={24} />
            <Typography variant={"title3"} className="text-end">
              CPAT
            </Typography>
          </div>
          <div className="flex flex-col gap-1">
            <Typography
              variant={"strongSmallBody"}
              className="text-onSurface-500"
            >
              {formatDate(dateCreated, "dd MMM yyyy")}
            </Typography>
            <Typography variant={"title1"}>Proctoring Report</Typography>
            <div className="flex flex-row items-center gap-1">
              <Avatar
                className="size-3.5"
                name={fullName}
                src={profile.picture}
              />
              <Typography variant={"subtitle1"} className="text-onSurface-700">
                {fullName}
              </Typography>
            </div>
          </div>
        </div>
      </PageContainer>
    </div>
  )
}

export default GradientHeader
